import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  adminData: null, // To store admin data
};

const adminDataSlice = createSlice({
  name: "adminDataSlice",
  initialState,
  reducers: {
    setAdminData: (state, action) => {
      state.adminData = action.payload;
    },
    clearAdminData: (state) => {
      state.adminData = null;
    },
  },
});

export const { setAdminData, clearAdminData } = adminDataSlice.actions;

export default adminDataSlice.reducer;
